import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';
import { useLocale } from '../use-locale.hook';

export const useDividendExport = () => {
  const { locale } = useLocale();

  const { isPending: isExportingAll, mutate: exportAll } = useAppMutation(
    [QueryKey.EXPORT_DIVIDEND_ALL],
    {
      mutationFn: () =>
        ApiService.downloadFile(
          { endpoint: BackendRoute.DIVIDENDS, routePath: ['export'] },
          { locale },
        ),
    },
  );

  const { isPending: isExportingPayout, mutate: exportPayout } = useAppMutation<
    unknown,
    unknown,
    { payoutId: string }
  >([QueryKey.EXPORT_DIVIDEND_PAYOUT], {
    mutationFn: ({ payoutId }) =>
      ApiService.downloadFile(
        { endpoint: BackendRoute.DIVIDENDS, routePath: [payoutId, 'export'] },
        { locale },
      ),
  });

  const { isPending: isExportingStakeholder, mutate: exportStakeholderPayouts } = useAppMutation<
    unknown,
    unknown,
    { stakeholderId: string; stakeholderName: string }
  >([QueryKey.EXPORT_DIVIDEND_STAKEHOLDER], {
    mutationFn: ({ stakeholderId, stakeholderName }) =>
      ApiService.downloadFile(
        { endpoint: BackendRoute.DIVIDENDS, routePath: ['stakeholder-payouts', 'export'] },
        { locale, queryParams: { stakeholderId, stakeholderName } },
      ),
  });

  return {
    exportAll,
    exportPayout,
    exportStakeholderPayouts,
    isExportingAll,
    isExportingPayout,
    isExportingStakeholder,
  };
};
